module.exports = __webpack_public_path__ + "img/bf.c687a881.svg";